<template>
  <text-input v-bind="$attrs" :placeholder="$t(props.placeholder)">
    <template #prepend-inner>
      <SearchAiSvg
        v-if="props.ai"
        width="24"
        height="24"
        class="mr-1 inline-block shrink-0"
        aria-hidden="true"
      />
      <Icon v-else :name="IconName.SEARCH" :size="IconSize.SM" class="mr-1" />
    </template>
    <template v-for="name in forwardedSlots" :key="name" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </text-input>
</template>

<script setup>
import { Icon, IconName, IconSize } from '@exfluential/ui';
import { computed, useSlots } from 'vue';
import { TextInput } from '../text-input';
import SearchAiSvg from '~/assets/images/search-ai.svg?component';

const props = defineProps({
  placeholder: {
    type: String,
    default: 'common.search',
  },
  ai: {
    type: Boolean,
    default: false,
  },
});

const slots = useSlots();

const forwardedSlots = computed(() =>
  Object.keys(slots).filter((name) => name !== 'prepend-inner'),
);
</script>
